.pad {
  composes: pad pressable from './surface.module.css';

  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  aspect-ratio: 1;
  min-width: 0;
  padding: var(--s2);
  text-align: left;
  touch-action: manipulation;
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

.mini {
  min-width: var(--target);
  width: var(--target);
  height: var(--target);
  padding: 0;
  align-items: center;
  justify-content: center;
}

.glyph::before {
  content: '';
  width: 14px;
  height: 16px;
  background: var(--ink);
  clip-path: polygon(0 0, 100% 50%, 0 100%);
}

.pad.lit.glyph::before {
  background: var(--onLed);
}

.id {
  font-size: 0.875rem;
  line-height: 1.4;
  font-weight: 500;
  font-stretch: 90%;
  color: var(--ink2);
}

.role {
  font-stretch: 90%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 650;
}

/* Has a sample */
.dot {
  position: absolute;
  top: var(--s3);
  right: var(--s3);
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--ink2);
}

.selected {
  composes: selected from './surface.module.css';
}

/* Specificity beats the composed .pad surface. Lit: solid --lit fill, --onLed text in both themes, no glow (DECISIONS 2026-09-23) */
.pad.lit {
  background: var(--lit);
  color: var(--onLed);
}

.pad.lit .id {
  color: var(--onLed);
}

.pad.lit .dot {
  background: var(--onLed);
}
